import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { ApiService } from './api.service';

@Injectable()
export class QuotaShipService extends ApiService {
  constructor(private http: Http) {
    super('api/quotas-ships/', http);
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/quotaship.service.ts